import {cssTheme} from '../theme'
import {css} from '../theme/css'
import {spacing} from '../theme/theme'

export const classes = {
  root: css`
    padding: ${spacing(0, 0, 2, 1)};
    box-shadow: 0 -2px 0 -1px ${cssTheme.default.day.line} inset;
    margin-bottom: ${spacing(1)};
  `,
}
